export function getScaledViewport(scale: number): {
	width: number;
	height: number;
} {
	const viewport = getViewport();
	return {
		width: Math.floor(viewport.width * scale),
		height: Math.floor(viewport.height * scale)
	};
}
